// import Login from './Index.vue'

const Login = () => import("./Index.vue");
import ResetPassword from './ResetPassword.vue'


export default [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresAuth: false,
      requiresCompany: false,
      showInMenu: false,
      label: "Login",
      icon: "fa fa-user",
    },
  },

  {
    path: "/security/password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      requiresAuth: false,
      requiresCompany: false,
      showInMenu: false,
      label: "Resetar Senha",
      icon: "fa fa-key",
    },
  }
];
